import { styled } from '@styles/stitches';

export const Content = styled('div', {
  marginTop: 16,
  maxHeight: '60vh',
  overflowY: 'auto',

  '@bp1': {
    height: 300,
    maxHeight: '50vh',
  },
});

export const User = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '$space$4 0',
});

export const Profile = styled('div', {
  display: 'flex',
});

export const Info = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 8,

  '& > *': {
    lineHeight: 1,
    fontSize: 14,
    margin: 0,
    marginBottom: 4,
  },
});
